import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcComponent } from '../fc';
/**
 * fc-layoutcolå·¦å³å¸å±
 * 
 * å·¦å³å¸å±ç»ä»¶ã
 * 
 * éè¦å·¦å³å¸å±æ¶å¯ä»¥åä¸ºä¸¤åæç§æ¯ä¾åååºåã
 * 
 */
@Component({
    selector: 'fc-layoutcol',
    template: `
    <div nz-row class="fc-layoutcol fc-full" [ngClass]="{fcClass:fcClass!==undefined}">
        <div nz-col [nzSpan]="_spans[0]"  class="fc-content1">
            <ng-content select="[fccontent1]" style="width:100%;height:100%;"></ng-content>
        </div>
        <div nz-col [nzSpan]="_spans[1]" class="fc-content2">
            <ng-content select="[fccontent2]" style="width:100%;height:100%;"></ng-content>
        </div>
    </div>
    `, styles: [`
    .fc-full{
        width:100%;
        height:100%;
    }
`]
})
export class FclayoutcolComponent extends FcComponent {
     /** å·¦å³æ¯ä¾ */
    @Input()
    fcSpans: string;
    _spans: number[] = [];
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-layoutcol');
        if (this.fcSpans === undefined) {
            this._spans = [12, 12];
        }
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcSpans !== undefined) {
            this.processSpans();
        }
    }
    /**
     * å¤çå¼åèä¼ å¥çåæ°ï¼èªå¨æ ¹æ®æé¿æå¨æ¯éç®åºå®éå¼ã
     */
    private processSpans(): void {
        this._spans = [];
        let spans = this.fcSpans.split(',');
        let sum = 0;
        spans.forEach(span => {
            sum += Number.parseInt(span);
        });
        spans.forEach(span => {
            let num = Number.parseInt(span);
            this._spans.push(Math.round(num * 24 / sum));
        });
    }
}
